import { ConsentType } from '../../api/auth';
import ConsentForm, { Values as FormValues } from '../forms/consent';
import ModalV2 from './modal-v2';

interface ConsentEditModalProps {
  open: boolean;
  consent: ConsentType | null;
  loading?: boolean;
  fixedType?: 'Mentor' | 'Founder';
  onClose: () => void;
  onSubmit: (
    values: FormValues & { id: string; orderNo?: number },
    callback: () => void,
  ) => void;
}

export function ConsentEditModal({
  open,
  consent,
  loading = false,
  fixedType,
  onClose,
  onSubmit,
}: ConsentEditModalProps) {
  const handleSubmit = (values: FormValues) => {
    if (consent) {
      onSubmit(
        {
          id: consent.id,
          orderNo: consent.orderNo,
          ...values,
          type: fixedType || values.type,
        },
        onClose,
      );
    }
  };

  if (!consent) {
    return null;
  }

  return (
    <ModalV2
      open={open}
      onClose={onClose}
      width='720px'
      titleProps={{
        title: 'Commitment editing',
      }}>
      <ConsentForm
        title=''
        consent={consent}
        fixedType={fixedType}
        loading={loading}
        onSubmit={handleSubmit}
        onCancel={onClose}
      />
    </ModalV2>
  );
}
